var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useOnOutClick } from '@hooks/useOnOutClick';
import React from 'react';
import { BsThreeDots } from 'react-icons/bs';
function MoreOptions(_a) {
    var show = _a.show, options = _a.options, onOutClick = _a.onOutClick, toggleHandler = _a.toggleHandler;
    var _b = __read(useOnOutClick(onOutClick), 2), containerRef = _b[0], divRef = _b[1];
    function clickHandler(e) {
        e.stopPropagation();
        toggleHandler();
    }
    var optionsItems = options.map(function (_a) {
        var Icon = _a.Icon, title = _a.title, action = _a.action, color = _a.color;
        return (React.createElement("div", { key: title, onClick: function () {
                toggleHandler();
                action();
            }, style: {
                color: color,
                padding: 5,
                width: '100%',
                display: 'flex',
                cursor: 'pointer',
                alignItems: 'center',
            } },
            React.createElement(Icon, { color: color }),
            React.createElement("span", { style: { paddingLeft: 15 } }, title)));
    });
    var optionsWindow = show ? (React.createElement("div", { ref: containerRef, style: {
            left: 'calc(100% - 150px)',
            top: '70%',
            width: 150,
            zIndex: 1000,
            borderRadius: 5,
            position: 'absolute',
            backgroundColor: 'white',
            border: '1px solid #E7EAF0',
            boxShadow: '0px 4px 16px rgba(107, 131, 160, 0.15)',
        } }, optionsItems)) : null;
    return (React.createElement("div", { style: { marginLeft: 15, display: 'flex', alignItems: 'center', position: 'relative' } },
        React.createElement("div", { ref: divRef },
            React.createElement(BsThreeDots, { cursor: "pointer", onClick: clickHandler })),
        optionsWindow));
}
export default MoreOptions;
